import LPBenefitForm from '../../benefit-lp-details/components/benefit-form';
import CommentDialog from './commentary-dialog';
import RefuseDialog from './refuse-dialog';
import ApproveDialog from './approve-dialog';

export default function ProductForm({ hook }: { hook: any }) {
  return (
    <>
      <LPBenefitForm hook={hook} benefitType="product" editDialog={<CommentDialog hook={hook} />} />
      <RefuseDialog hook={hook} />
      <ApproveDialog hook={hook} />
    </>
  );
}
